<template>
  <v-row>
    <v-col cols="7" class="mx-n4">
      <v-card-title>Indexation via robots - SEO</v-card-title>
    </v-col>
    <v-col cols="10" class="mt-n8">
      <v-switch
        v-model="actionValue.robotsIndex"
        label="Indexer cette page"
        color="blue"
        hint="Désactivé = la page ne sera pas indexée par Google"
        persistent-hint
      />
    </v-col>
  </v-row>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({ action: { type: Object, required: true } });

const actionValue = ref(props.action);

</script>
